module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo08-6718731c4312b358c6088848e67a18e9.jpg";